import Dashboard from "../Pages/Dashboard/Dashboard";
import ProjectList from "../Pages/Masters/ProjectList";
import ProjectProfile from "../Pages/Masters/ProjectProfile";
import ManageDocument from '../Components/ManageProject/Document'
import ManageContractorList from "../Components/ManageProject/ContractorList"
import ManageConsultantList from "../Components/ManageProject/ConsultantList"
import ManageGallery from "../Components/ManageProject/Gallery"
import ItemList from "../Pages/Masters/ItemList";
import ManageTask from "../Components/ManageProject/Task";
import AllRequests from "../Pages/Masters/AllRequests";
import AllProjectList from "../Pages/Masters/AllProjectList"
import ActiveProjects from "../Pages/Dashboard/ActiveProjects";
import CompletedProjects from "../Pages/Masters/CompletedProjects";
import PendingProjects from "../Pages/Masters/PendingProjects";
import PendingRequest from "../Pages/Masters/PendingRequest";
import InspectionRequest from "../Pages/Masters/InspectionRequest";
import ManageInspectionFormThroughProfile from "../Components/ManageProject/InspectionFormThroughProfile";
import ManageAllItemRequestList from "../Components/ManageProject/AllItemRequest";
import ManageAssignedItem from "../Components/ManageProject/AssignedItems";
import AccountInformation from "../Pages/AccountInformation";

// routes.js
const routes = [
  ////////////////////// Dashboard Routing ///////////////////////////
  { path: "/", element: <Dashboard /> },
  { path: "/AccountInformation", element: <AccountInformation /> },
  { path: "/AllRequests", element: <AllRequests /> },
  { path: "/CompletedProjects", element: <CompletedProjects /> },
  { path: "/PendingProjects", element: <PendingProjects /> },
  { path: "/PendingRequests", element: <PendingRequest /> },
  { path: "/InspectionRequest", element: <InspectionRequest /> },

  ////////////////////// Master's Routing ///////////////////////////
  { path: "/ProjectList", element: <ProjectList /> },
  { path: "/AllProjectList", element: <AllProjectList /> },

  ////////////////////// Master's Products Start ///////////////////////////
  { path: "/ProjectProfile/:project_id?", element: <ProjectProfile /> },
  { path: "/ProjectProfile/:project_id?", element: <ActiveProjects /> },
  // { path: "/Documents", element: <ManageDocument /> },
  // { path: "/ContractorList", element: <ManageContractorList /> },
  // { path: "/ConsultantList", element: <ManageConsultantList /> },
  // { path: "/Gallery", element: <ManageGallery /> },


  // Item List 
  { path: "/ItemList/:project_id", element: <ItemList /> },



  //////////////////// Project's Routing ///////////////////////////
  { path: "/ProjectProfile/:project_id?", element: <ProjectProfile /> },
  { path: "/Documents/:project_id?", element: <ManageDocument /> },
  { path: "/ContractorList/:project_id?", element: <ManageContractorList /> },
  { path: "/ConsultantList/:project_id?", element: <ManageConsultantList /> },
  { path: "/Gallery/:project_id?", element: <ManageGallery /> },
  { path: "/Task/:project_id?", element: <ManageTask /> },
  { path: "/Inspection/:project_id", element: <ManageInspectionFormThroughProfile /> },
  { path: "/AllItemRequest/:project_id?", element: <ManageAllItemRequestList /> },
  { path: "/AssignedItems/:project_id?", element: <ManageAssignedItem /> },

];

export default routes;
